import React from 'react';
import {
  X,
  History,
  RotateCcw,
  Download,
  Calendar,
  Clock,
  User,
  CheckCircle2,
  FileText,
} from 'lucide-react';
import { formatBytes } from './DocumentUploadModal';

export default function DocumentVersionHistoryModal({
  open,
  document,
  onClose,
  onRestoreVersion,
}) {
  if (!open || !document) return null;

  const versions = document.versions || [
    {
      version: 1,
      savedAt: document.created_at || new Date().toISOString(),
      modifier: document.owner || 'You',
      fileSize: document.fileSize || 102400,
      summary: 'Initial document uploaded and encrypted',
    },
  ];

  return (
    <div className="card-drawer-wrapper" role="presentation">
      <div className="card-drawer-overlay animate-fade-in" onClick={onClose} aria-hidden="true" />
      <aside
        className="card-drawer doc-drawer ios-doc-drawer document-versions-drawer animate-slide-left"
        role="dialog"
        aria-modal="true"
        aria-label="Document Version History"
      >
        <div className="card-drawer-header modal-header">
          <div className="modal-header-info">
            <div
              className="modal-icon-badge"
              style={{ background: 'rgba(6, 182, 212, 0.15)', color: '#06b6d4' }}
            >
              <History size={18} />
            </div>
            <div className="modal-header-titles">
              <h2 className="modal-title">Version History</h2>
              <p className="modal-subtitle">
                Inspect, download, or restore previous versions of "{document.title}".
              </p>
            </div>
          </div>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>

        <div className="card-drawer-body modal-body document-versions-body">
          <div className="versions-timeline">
            {versions.map((ver, idx) => {
              const isCurrent = idx === 0;
              return (
                <div
                  key={ver.version || idx}
                  className={`version-timeline-item ${isCurrent ? 'is-current' : ''}`}
                >
                  <div className="version-timeline-marker">
                    {isCurrent ? <CheckCircle2 size={16} className="text-success" /> : <div className="version-dot" />}
                  </div>

                  <div className="version-card glass-panel">
                    <div className="version-card-header">
                      <div className="version-title-row">
                        <span className="version-number-tag">Version {ver.version}</span>
                        {isCurrent && <span className="badge badge-success">Active / Current</span>}
                      </div>
                      <span className="version-date">
                        {new Date(ver.savedAt).toLocaleString()}
                      </span>
                    </div>

                    <p className="version-summary">
                      {ver.summary || 'Updated document fields & encrypted payload'}
                    </p>

                    <div className="version-footer-row">
                      <div className="version-specs">
                        <span>{formatBytes(ver.fileSize || document.fileSize)}</span>
                        <span>• Modified by {ver.modifier || document.owner || 'You'}</span>
                      </div>

                      <div className="version-actions-cluster">
                        {!isCurrent && onRestoreVersion && (
                          <button
                            type="button"
                            className="btn btn-xs btn-primary"
                            onClick={() => {
                              onRestoreVersion(ver);
                              onClose();
                            }}
                          >
                            <RotateCcw size={13} />
                            <span>Restore this Version</span>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="card-drawer-footer modal-footer">
          <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
            Close
          </button>
        </div>
      </aside>
    </div>
  );
}
